import { AuthLayout } from '../../components/layout/AuthLayout';
import { LoginForm } from './LoginForm';
import { InstallPWADrawer } from '../../components/data-display/InstallPWADrawer';

const LoginPage = () => {
  console.log("Endpoints Update check 1.1!");
  return (
    <AuthLayout>
      <div className="mb-8 text-center">
        <h2 className="mb-2 text-2xl sm:text-3xl font-bold text-[#333333]">Welcome Back</h2>
        <p className="text-[#555555] font-medium text-lg">Sign in to access your assigned fieldwork</p>
      </div>
      <LoginForm />
      <InstallPWADrawer />
    </AuthLayout>
  );
};

export default LoginPage;